import { lazy } from 'react'

import { ArrowLeft } from '@factorialco/f0-react/icons/app'
import { TrainingContentHeaderDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const Root = lazy(() => import('modules/trainings/pages/content/Root'))
const Builder = lazy(() => import('modules/trainings/pages/content/Builder'))

export const contentRoutes: NavigationRoutesFn = (navigation) => {
  const contentRoot = navigation.trainings.list.details_revamp.content
  return [
    {
      path: contentRoot.path,
      element: <Root />,
      handle: {
        resource: true,
        meta({ watchQuery, params }) {
          return watchQuery({
            query: TrainingContentHeaderDocument,
            fetchPolicy: 'cache-and-network',
            variables: {
              trainingId: String(params.id),
            },
          }).map(({ data }) => {
            const training = data.trainings.training
            return {
              headerComponentProps: {
                title: String(training?.name),
                primaryAction: {
                  key: 'preview',
                  label: i18n.t('common.preview'),
                },
                secondaryActions: [
                  {
                    key: 'back',
                    icon: ArrowLeft,
                    label: i18n.t('trainings.content.builder.back'),
                  },
                ],
              },
              title: i18n.t('trainings.content.builder.page_title'),
              subNavigation: [],
            }
          })
        },
      },
      children: [
        {
          path: contentRoot.builder.path,
          element: <Builder />,
        },
      ],
    },
  ]
}
